import { theme } from "@entersekt/types/build/3-5-0/endpoint";

function md5(input: string): string {
  if (!input) {
    return "";
  }
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return hash.toString(16);
}

function getStoredThemeHash(): string | null {
  return localStorage.getItem("themeObjectKey");
}

export function getStoredTheme(): theme | undefined {
  const themeHash = getStoredThemeHash();

  if (themeHash) {
    const cachedThemeObj = localStorage.getItem(themeHash);

    if (cachedThemeObj) {
      try {
        return JSON.parse(cachedThemeObj);
      } catch (e) {
        return;
      }
    }
  }
}

function storeTheme(themeToStore: theme) {
  const themeJSON = JSON.stringify(themeToStore);
  const themeHash = md5(themeJSON);
  localStorage.setItem(themeHash, themeJSON);
  localStorage.setItem("themeObjectKey", themeHash);
}

export function handleCachedTheme(
  cachedTheme: theme,
  templateContentTheme: theme,
): theme | undefined {
  const isCachedThemeEmpty = Object.keys(cachedTheme).length === 0;
  const isTemplateContentThemeEmpty =
    Object.keys(templateContentTheme).length === 0;

  if (isCachedThemeEmpty) {
    storeTheme(templateContentTheme);
    return templateContentTheme;
  }

  const cachedThemeHash = getStoredThemeHash();
  const newThemeHash = md5(JSON.stringify(templateContentTheme));
  if (!isTemplateContentThemeEmpty && cachedThemeHash !== newThemeHash) {
    if (cachedThemeHash) {
      localStorage.removeItem(cachedThemeHash);
      localStorage.removeItem("themeObjectKey");
    }
    storeTheme(templateContentTheme);
    return templateContentTheme;
  }
  return cachedTheme;
}

export function cacheImages(images: string[]) {
  const imagesString = images.toString();
  const newImagesHash = md5(imagesString);
  const storedImageHash = localStorage.getItem("imageHash");

  if (newImagesHash !== storedImageHash) {
    if (storedImageHash) {
      localStorage.removeItem(storedImageHash);
      localStorage.removeItem("imageHash");
    }
    localStorage.setItem("imageHash", newImagesHash);
    localStorage.setItem(newImagesHash, imagesString);
  }
}

export function getCachedImages(): string[] | undefined {
  const imageHash = localStorage.getItem("imageHash");
  if (imageHash) {
    const images = localStorage.getItem(imageHash);
    if (images) {
      return images?.split(",");
    }
  }
}
